import { FC, useEffect } from "react";
import "../styles/LoadingAnim.scss";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import userImage from "../../../assets/images/defaultAvatar.png";
import { useAppSelector } from "../../../hooks/store.hooks";
import store from "../../../store/store";
import { addBreadcrumb } from "../../../components/Breadcrumbs/reducer/breadcrumbSlice";
import { Button } from "../../../components/Button";

const EditPageButtonLink: FC<{ productId: any; cell: any }> = ({
  productId,
  cell,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  console.log('productId', productId)
  console.log('cell', cell)

  const breadcrumbHandle = async (productId: any, cell: any) => {
    const data: any = [
      {
        label: "Product",
        link: `/products`,
      },
      {
        label: cell?.values?.name ? cell?.values?.name : cell?.value?.sku,
        link: `/products/${productId}`,
      },
    ];
    // const data: any = {};
    store.dispatch(addBreadcrumb(data));
    navigate(`/products/edit/${productId}`);
  };

  return (
    <Button
      onClick={() => breadcrumbHandle(productId, cell)}
      apparence="success"
      view="default"
      type="submit"
      size="md"
    >
      <div className="font-normal text-base">Edit</div>
    </Button>
  );
};

export default EditPageButtonLink;
